// extracted by mini-css-extract-plugin
module.exports = {"pageCard":"style-module__pageCard___23CLK"};